import React from 'react';

const Header = ({
  mode,
  setMode,
  models,
  modelsLoading,
  selectedModel,
  setSelectedModel,
  modelSearchTerm,
  setModelSearchTerm,
  isModelDropdownOpen,
  setIsModelDropdownOpen,
  modelDropdownRef,
  toggleModelDropdown,
  getSelectedModelName,
  handleModelSelect,
  handleModelSearchChange,
  filteredModels,
  gpt4freeModels,
  selectedGpt4freeModel,
  setSelectedGpt4freeModel,
  gpt4freeModelsLoading
}) => {
  return (
    <header className="App-header">
      <h1>AGK Fire AI Chat</h1>
      <div className="header-controls">
        <div className="mode-toggle">
          <button
            className={`mode-btn ${mode === 'gpt4free-chat' ? 'active' : ''}`}
            onClick={() => setMode('gpt4free-chat')}
          >
            🤖 G4F Chat
          </button>
          <button
            className={`mode-btn ${mode === 'gpt4free-image' ? 'active' : ''}`}
            onClick={() => setMode('gpt4free-image')}
          >
            🎨 G4F Image
          </button>
          <button
            className={`mode-btn ${mode === 'gpt4free-audio' ? 'active' : ''}`}
            onClick={() => setMode('gpt4free-audio')}
          >
            🎵 G4F Modality
          </button>
          <button
            className={`mode-btn ${mode === 'gpt4free-tts' ? 'active' : ''}`}
            onClick={() => setMode('gpt4free-tts')}
          >
            🔊 G4F TTS
          </button>
          <button
            className={`mode-btn ${mode === 'chat' ? 'active' : ''}`}
            onClick={() => setMode('chat')}
          >
            💬 Chat
          </button>
          <button
            className={`mode-btn ${mode === 'image' ? 'active' : ''}`}
            onClick={() => setMode('image')}
          >
            🎨 Image
          </button>
          <button
            className={`mode-btn ${mode === 'img2txt' ? 'active' : ''}`}
            onClick={() => setMode('img2txt')}
          >
            🔍 Analyze
          </button>
          <button
            className={`mode-btn ${mode === 'txt2speech' ? 'active' : ''}`}
            onClick={() => setMode('txt2speech')}
          >
            🔊 Speech
          </button>
        </div>
        {mode === 'chat' && (
          <div className="model-selector" ref={modelDropdownRef}>
            <label>Model:</label>
            <div className="searchable-dropdown">
              <div
                className={`dropdown-trigger ${modelsLoading ? 'disabled' : ''}`}
                onClick={modelsLoading ? undefined : toggleModelDropdown}
              >
                <span className="selected-model">{getSelectedModelName()}</span>
                <span className="dropdown-arrow">{isModelDropdownOpen ? '▲' : '▼'}</span>
              </div>
              {isModelDropdownOpen && (
                <div className="dropdown-menu">
                  <input
                    type="text"
                    className="model-search"
                    placeholder="Search models..."
                    value={modelSearchTerm}
                    onChange={handleModelSearchChange}
                    autoFocus
                  />
                  <div className="dropdown-options">
                    {filteredModels.length > 0 ? (
                      filteredModels.map(model => (
                        <div
                          key={model.id}
                          className={`dropdown-option ${model.id === selectedModel ? 'selected' : ''}`}
                          onClick={() => handleModelSelect(model.id)}
                          title={model.description}
                        >
                          <div className="model-name">{model.name}</div>
                          <div className="model-id">{model.id}</div>
                        </div>
                      ))
                    ) : (
                      <div className="no-results">No models found</div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {(mode === 'gpt4free-chat' || mode === 'gpt4free-image' || mode === 'gpt4free-audio') && (
          <div className="model-selector" ref={modelDropdownRef}>
            <label>G4F Model:</label>
            <div className="searchable-dropdown">
              <div
                className={`dropdown-trigger ${gpt4freeModelsLoading ? 'disabled' : ''}`}
                onClick={gpt4freeModelsLoading ? undefined : () => setIsModelDropdownOpen(!isModelDropdownOpen)}
              >
                <span className="selected-model">
                  {gpt4freeModelsLoading ? 'Loading...' :
                   (() => {
                     console.log('G4F models available:', gpt4freeModels);
                     console.log('Selected G4F model:', selectedGpt4freeModel);
                     const foundModel = gpt4freeModels.find(m => m.id === selectedGpt4freeModel);
                     console.log('Found model:', foundModel);
                     return foundModel?.name || selectedGpt4freeModel || 'No model selected';
                   })()}
                </span>
                <span className="dropdown-arrow">{isModelDropdownOpen ? '▲' : '▼'}</span>
              </div>
              {isModelDropdownOpen && (
                <div className="dropdown-menu">
                  <div className="dropdown-options">
                    {(() => {
                      // Filter models based on current mode
                      const modelType = mode === 'gpt4free-chat' ? 'chat' :
                                      mode === 'gpt4free-image' ? 'image' :
                                      mode === 'gpt4free-tts' ? 'audio' : 'audio';
                      const filteredModels = gpt4freeModels.filter(model => model.type === modelType);

                      console.log('Filtering models for mode:', mode);
                      console.log('Target model type:', modelType);
                      console.log('All models:', gpt4freeModels);
                      console.log('Filtered models:', filteredModels);

                      return filteredModels.length > 0 ? (
                        filteredModels.map(model => (
                          <div
                            key={model.id}
                            className={`dropdown-option ${model.id === selectedGpt4freeModel ? 'selected' : ''}`}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent dropdown from closing
                              e.preventDefault(); // Prevent any default behavior
                              console.log('Clicked on model:', model.id, model.name);
                              setSelectedGpt4freeModel(model.id);
                              console.log('Set selected model to:', model.id);
                              setIsModelDropdownOpen(false);
                              console.log('Closed dropdown');
                            }}
                            title={model.description}
                          >
                            <div className="model-name">{model.name}</div>
                            <div className="model-id">{model.type}</div>
                          </div>
                        ))
                      ) : (
                        <div className="no-results">No {modelType} models available</div>
                      );
                    })()}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;